<template>
  <div>
    <input type="file" onchange="importf(this)" />
    <div>
      <el-table
          :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
          style="width: 100%"
      >
        <el-table-column
            v-for="(item,key,index) in tableData[0]"
            :key="index"
            :prop="key"
            :label="key"
            width="180"
        ></el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[15, 20, 30, 40]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.length"
      >
      </el-pagination>
  </div>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  name: "xmlTest",
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pagesize: 15
    }
  },
  methods: {
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
      this.pagesize = size;
      console.log(this.pagesize); //每页下拉显示数据
    },
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      console.log(this.currentPage); //点击第几页
    },
    importf: function (obj) {
      console.log("11")
      //导入
      if (!obj.files) {
        return;
      }
      var f = obj.files[0];
      console.log(f);
      var reader = new FileReader();
      var jsonobject_0;
      // var result = [];
      reader.onload = function(e) {
        var data = e.target.result;
        //获取xlsx对象
        var workbook = XLSX.read(data, {
          type: "binary"
        });

        jsonobject_0 = XLSX.utils.sheet_to_json(
            workbook.Sheets[workbook.SheetNames[0]]
        );
        this.tableData = jsonobject_0;
        console.log(jsonobject_0);
      };
      reader.readAsBinaryString(f);
    }
  }

}
</script>

<style scoped>

</style>
